import React from 'react';
import { styled } from '@glitz/react';
import connect from 'Shared/connect';
import ProductCartItem from '../../Product/ProductCartItem';
import ValidationItem from '../../Product/ProductCartItem/ValidationItem';
import { updateCartItemQuantity, removeCartItem } from '../action-creators';
import { CartType } from 'Shared/State';
import CheckoutLabels from '../Pages/Checkout/CheckoutPageViewModel+CheckoutLabels.type';
import BackupStoreModel from 'Checkout/Pages/Checkout/BackupStoreModel.type';
import CartValidationItem from 'Cart/Models/CartValidationItem.type';

const Base = styled.div({});

type RequiredPropType = {
  cart: CartType;
  labels: CheckoutLabels;
  backupStore?: BackupStoreModel;
  isMobile: boolean;
  validationItems: CartValidationItem[];
};

type PropType = RequiredPropType & {
  updateCartItemQuantity: (lineId: number, code: string, quantity: number) => Promise<void>;
  removeCartItem: (lineId: number, code: string, previousQuantity: number) => Promise<void>;
};

const FullCart = (props: PropType) => {
  return (
    <Base>
      {props.cart?.items?.map((item) => (
        <ProductCartItem
          key={'line' + item.lineItemId}
          backupStore={props.backupStore}
          labels={props.labels}
          isMobile={props.isMobile}
          item={item}
          incompleteOffer={props.cart.incompleteOffer}
          update={props.updateCartItemQuantity}
          remove={props.removeCartItem}
        />
      ))}
      {props.validationItems &&
        props.validationItems.map((item) => (
          <ValidationItem key={item.id} labels={props.labels} isMobile={props.isMobile} item={item} />
        ))}
    </Base>
  );
};

export default connect(
  (state) => ({}),
  (dispatch) => ({
    updateCartItemQuantity(lineId: number, code: string, quantity: number) {
      return dispatch(updateCartItemQuantity(lineId, code, quantity, 'Kassasida'));
    },
    removeCartItem(lineId: number, code: string, previousQuantity: number) {
      return dispatch(removeCartItem(lineId, code, previousQuantity, 'Kassasida'));
    },
  }),
)(FullCart);
